<template>
  <!-- 通知公告页面 -->
  <section class="container">
    <Header></Header>
    <div class="wrapper RuleM">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt="">
          当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>通知公告</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="innerM">
        <div class="title">
          通知公告
        </div>
        <div class="ruleM">
          <div class="rule flex-row" v-for="(data, index) in dataList" :key="index" @click="viewClick" :data-id="data.articleId">
            <div class="col-3">
              <div class="point"></div>
            </div>
            <div class="col-87 text-left overflow pointer">
              <Tooltip max-width="300" :content='data.title' placement="top">
                {{data.title}}
              </Tooltip>
            </div>
            <div class="col-10 text-right date">
              {{data.createDate}}
            </div>
          </div>
        </div>
        <div class="pageM">
          <Page v-if="dataList.length > 0" :total="total" :current.sync="page" @on-change="pageClick"/>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  export default {
    name: "Announcement",
    data(){
      return {
        total: 10,
        page: 1,
        dataList: []
      }
    },
    methods: {
      viewClick(e){
        this.$router.push('/AnnouncementArticle/' + e.currentTarget.dataset.id);
      },
      pageClick(){
        this.listArticle();
      },
      listArticle(){
        var that = this;
        var data = {
          "articleColumn": 3,
          "page": that.page,
          "size": "10"
        };
        this.$http({
          url: that.webhost + 'article/list',
          method: 'POST',
          data: data
        }).then(({data}) => {
          if (data && data.code === 0) {
            that.dataList = data.data.list;
            that.total = data.data.totalCount;
          } else {
            that.$Message.error(data.msg);
          }
        })
      }
    },
    mounted(){
      this.listArticle();
      this.setTab();
    },
    components: {
      Header,
      Footer
    }
  }
</script>

<style scoped>
  .wrapper{
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 90px;
    font-family: "PingFang SC";
  }
  .title{
    text-align: left;
    font-size: 25px;
    line-height: 72px;
    color: #000;
    border-bottom: solid 2px #ccc;
  }
  .locationM{
    height: 50px;
    line-height: 50px;
  }
  .locationM .ivu-breadcrumb{
    font-size: 15px;
    color: #000;
  }
  .locationM img{
    width: 23px;
    height: 22px;
    margin-right: 5px;
    position: relative;
    top: 3px;
  }
  .ruleM{
    padding: 20px 0;
    min-height: 400px;
  }
  .rule{
    font-size: 17px;
    height: 35px;
    line-height: 35px;
    position: relative;
  }
  .col-3{
    width: 3%;
  }
  .col-87{
    width: 87%;
  }
  .rule .point{
    width: 10px;
    height: 10px;
    background: #1a87cc;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
  .date{
    color: #999;
  }
</style>

<style>
  .RuleM .ivu-page-item, .ivu-page-prev, .ivu-page-next{
    border-radius: 0;
  }
  .RuleM .ivu-page-item.ivu-page-item-active{
    background: #0070bd;
  }
  .RuleM .ivu-page-item-active a{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/Announcement.vue